// # Point
// Two-dimensional point in schematic-space.
export interface Point {
  x: number;
  y: number;
}

export const Point = {
  new: (x: number, y: number): Point => ({ x, y }),
  origin: (): Point => Point.new(0, 0),
  eq: (a: Point, b: Point) => a.x === b.x && a.y === b.y,
  add: (a: Point, b: Point): Point => ({ x: a.x + b.x, y: a.y + b.y }),
  sub: (lhs: Point, rhs: Point): Point => ({
    x: lhs.x - rhs.x,
    y: lhs.y - rhs.y,
  }),
  scale: (p: Point, s: number): Point => ({ x: p.x * s, y: p.y * s }),
  neg: (p: Point): Point => Point.scale(p, -1),
  clone: (p: Point): Point => Point.new(p.x, p.y),
  dist: (a: Point, b: Point): number => {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  },
};
